import React from "react";
import { getWarehouseProfile, getWarehouseSingleOrderConfiguration } from "../../api/warehouseConfigurationAPI";
import { resolveProfile } from "./profiles/resolveProfile";
import { LoaderBox } from "../../components/utilities";
import { Roles } from "../../auth/rolesPermissions";
import { readUserContext, saveUserContext } from "../../auth/sessionService";

export default class WarehousePage extends React.Component {
    constructor(props) {
        super(props);

        this._isMounted = false;

        this.state = {
            ready: false,
            error: "",
            profile: null,
            configuration: null,
            userContext: null
        };
    }

    async componentDidMount() {
        this._isMounted = true;

        try {
            const userContext = readUserContext();

            if (!userContext?.jwtToken) {
                throw new Error("Sessione utente non disponibile.");
            }

            const isWarehouseUser = userContext.userRole === Roles.WAREHOUSEADMIN || userContext.userRole === Roles.WAREHOUSEUSER;

            if (!isWarehouseUser) {
                throw new Error("La sessione non appartiene a un utente warehouse.");
            }

            let configuration;
            let shouldSaveProfile = false;

            if (this.props.page === "orderCreation") {
                configuration = await getWarehouseSingleOrderConfiguration(userContext.jwtToken);
            } else {
                const hasSessionProfile = typeof userContext.warehouseProfileCode === "string" && userContext.warehouseProfileCode.trim() !== "";

                if (hasSessionProfile) {
                    configuration = {
                        profileCode: userContext.warehouseProfileCode
                    };
                } else {
                    configuration = await getWarehouseProfile(userContext.jwtToken);
                    shouldSaveProfile = true;
                }
            }

            if (!this._isMounted) {
                return;
            }

            const profile = resolveProfile(configuration.profileCode);

            if (!profile.pages || !profile.pages[this.props.page]) {
                throw new Error("Pagina warehouse non configurata per il profilo.");
            }

            if (shouldSaveProfile) {
                userContext.warehouseProfileCode = configuration.profileCode;

                if (!saveUserContext(userContext)) {
                    throw new Error("Impossibile aggiornare la sessione warehouse.");
                }
            }

            this.setState({
                ready: true,
                error: "",
                profile,
                configuration,
                userContext
            });
        } catch (error) {
            if (this._isMounted) {
                this.setState({
                    error: error.message || "Impossibile caricare la configurazione warehouse."
                });
            }
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        if (this.state.error) {
            return (
                <div className="alert alert-danger" role="alert">
                    {this.state.error}
                </div>
            );
        }

        if (!this.state.ready) {
            return (
                <div className="warehouse-initial-loader">
                    <LoaderBox />
                </div>
            );
        }

        const PageContent = this.state.profile.pages[this.props.page];

        return (
            <PageContent
                key={this.state.profile.code}
                {...this.props}
                profile={this.state.profile}
                configuration={this.state.configuration}
                userContext={this.state.userContext}
            />
        );
    }
}